import { AlertCircle } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

const CONTAINER_VARIANTS = {
  screen: "flex items-center justify-center min-h-screen",
  full: "flex items-center justify-center h-full",
};

export default function ErrorState({
  error,
  onRetry,
  variant = "screen",
  className = "",
}) {
  if (!error) return null;

  const containerClass =
    CONTAINER_VARIANTS[variant] ?? CONTAINER_VARIANTS.screen;

  return (
    <div className={`${containerClass} ${className}`}>
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <CardTitle className="text-destructive flex items-center gap-2 text-center justify-center">
            <AlertCircle className="w-5 h-5" />
            <span>Error</span>
          </CardTitle>
        </CardHeader>

        <CardContent>
          <p className="text-sm text-muted-foreground">
            {error || "Something went wrong"}
          </p>
          <button
            onClick={onRetry || (() => window.location.reload())}
            className="mt-4 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90"
          >
            Retry
          </button>
        </CardContent>
      </Card>
    </div>
  );
}